module.exports = __webpack_public_path__ + "img/21-s.33bf28d2.png";